import React from 'react'
import { WHITE } from '@omnilert/components'
const ArrowUp = () => (
  <svg
    fill='none'
    viewBox='0 0 13 14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g
      clipPath='url(#clip0)'
      stroke={WHITE}
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M6.5.5v13M1 6L6.5.5 12 6' />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path
          d='M12.5 14H24.5V28H12.5z'
          fill={WHITE}
          transform='rotate(-180 12.5 14)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default ArrowUp
